export class ConstantsStorage {
    
    static readonly LOGIK_CSV: string = "LOGIK_CSV";
    static readonly IS_CSV_UPLOAD : string = "IS_CSV_UPLOAD";
  }
  